import { defineMessages } from 'react-intl';

export default defineMessages({
	lblAmendSeatReservationsDialogTitle: {
		id: 'app.booking.amendSeatReservationsDialog.title',
		defaultMessage: 'Amend Seat Reservations',
	},
	lblBookingDialogTitle: {
		id: 'app.booking.amendBookingDialog.title',
		defaultMessage: 'Amend Booking',
	},
	btnClose: {
		id: 'app.close',
		defaultMessage: 'Close',
	},
	lblAmendSeatReservationsDialogAddSeat: {
		id: 'app.booking.amendSeatReservationsDialog.addSeat',
		defaultMessage: 'Keep Train and Add Seat',
	},
	lblAmendSeatReservationsDialogChangeSeat: {
		id: 'app.booking.amendSeatReservationsDialog.changeSeat',
		defaultMessage: 'Keep Train and Change Seat',
	},
	lblAmendSeatReservationsDialogChangeTrainAndSeat: {
		id: 'app.booking.amendSeatReservationsDialog.changeTrainAndSeat',
		defaultMessage: 'Change Train and Seat',
	},
	lblAmendSeatReservationsDialogSearchForTrains: {
		id: 'app.booking.amendSeatReservationsDialog.searchForTrains',
		defaultMessage: 'Search For Trains',
	},
	lblAmendSeatReservationsDialogSelectThisJourney: {
		id: 'app.booking.amendSeatReservationsDialog.selectThisJourney',
		defaultMessage: 'SELECT THIS JOURNEY',
	},
	lblAmendSeatReservationsDialogOutbound: {
		id: 'app.booking.amendSeatReservationsDialog.outbound',
		defaultMessage: 'Outbound',
	},
	lblAmendSeatReservationsDialogError: {
		id: 'app.booking.amendSeatReservationsDialog.error',
		defaultMessage: 'Error while validating seatmap information for this journey.',
	},
	lblAmendSeatReservationsDialogChanges: {
		id: 'app.booking.amendSeatReservationsDialog.changes',
		defaultMessage: 'Changes',
	},
	lblAmendSeatReservationsDialogDuration: {
		id: 'app.booking.amendSeatReservationsDialog.duration',
		defaultMessage: 'Duration',
	},
	lblAmendBookingNotAvailable: {
		id: 'app.booking.amendBookingDialog.amendError',
		defaultMessage:
			'This journey or existing seat reservations cannot be amended.',
	},
	lblExchangeBookingNotAvailable: {
		id: 'app.booking.amendBookingDialog.exchangeError',
		defaultMessage: 'This fare cannot be exchanged.',
	},
	lblExchangeAmendBookingNotAvailable: {
		id: 'app.booking.amendBookingDialog.exchangeAmendError',
		defaultMessage: 'This fare cannot be exchanged or amended.',
	},
	lblExchangeBooking: {
		id: 'app.booking.amendBookingDialog.exchangeBooking',
		defaultMessage: 'Exchange this ticket for another qualifying journey.',
	},
	lblAmendBooking: {
		id: 'app.booking.amendBookingDialog.amendBooking',
		defaultMessage:
			'Amend the journey to another qualifying journey, or rebook with alternative seat reservations.',
	},
	btnExchangeOrder: {
		id: 'app.booking.amendBookingDialog.exchangeOrder',
		defaultMessage: 'Exchange',
	},
	btnAmendOrder: {
		id: 'app.booking.amendBookingDialog.amendOrder',
		defaultMessage: 'Amend',
	},
	lblLegSelectionDialogTitle: {
		id: 'app.booking.legSelectionDialog.title',
		defaultMessage: 'Select Journey Legs',
	},
	lblLegSelectionDialogOutboundJourney: {
		id: 'app.booking.legSelectionDialog.outboundJourney',
		defaultMessage: 'Outbound journey',
	},
	lblLegSelectionDialogInboundJourney: {
		id: 'app.booking.legSelectionDialog.inboundJourney',
		defaultMessage: 'Inbound journey',
	},
	lblLegSelectionDialogCurrentBookingDetails: {
		id: 'app.booking.legSelectionDialog.currentBookingDetails',
		defaultMessage: 'Current booking details (inc seat details)',
	},
	btnNext: {
		id: 'app.common.next',
		defaultMessage: 'Next',
	},
	btnCancel: {
		id: 'app.common.cancel',
		defaultMessage: 'Cancel',
	},
});
